// @flow strict
import * as React from 'react';
import type { Theme } from '../theme-loader.js';

import alaskaStyles from './alaska-theme.css';
import akStarLogo from '../images/akStarLogo.png';

const alaskaTheme: Theme = {
  getLogo: () => {
    return <img height="56" src={akStarLogo} alt="AK Star Logo" data-cy="akStarLogo" />;
  },
  getWelcomePanelOverrideStyle: (): string => {
    return alaskaStyles.welcomePanelOverride;
  }
};

export default alaskaTheme;
